
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share-your-story/plug/[...plugId]",
      function () {
        return require("private-next-pages/share-your-story/plug/[...plugId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share-your-story/plug/[...plugId]"])
      });
    }
  